import {
    apiRequest,
    schedulerList,
    schedulerActive,
    schedulerInactive,
} from "../../../../../services/adapters/kepegawaian/schedulerService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", schedulerList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", schedulerInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", schedulerActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository